import { RouteObject } from "react-router";
import getResultSetLayer from "../../../../../../API/result_set_layer";
import download from "./download";
import ResultSetCrumb from "./ResultSetCrumb";
import ResultSetPage from "./ResultSetPage";
import { GetResultSetLayerParams } from "../../../../../../API/route-params.types";

const routes: RouteObject = {
  id: "resultSet",
  path: "result-set/:resultSetId",
  loader: (params) => ({
    data: getResultSetLayer(params as GetResultSetLayerParams),
  }),
  handle: {
    Crumb: ResultSetCrumb,
  },
  children: [download],
  Component: ResultSetPage,
};

export default routes;
